import customFetch from '../../utils/customFetch'
import { getDefaultLogger } from '../../services/logger/logger'
import { ListingCoordinates } from '../../@types/my-property-service-types'
import { API_ENDPOINT } from '../../config'

export const getListingCoordinates = async (listingId: string): Promise<ListingCoordinates | undefined> => {
  const url = `${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/listings/${listingId}/coordinates`

  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
    },
    credentials: 'include',
  }

  try {
    const response = await customFetch(url, options)
    if (response.status === 200) {
      return (await response.json()) as ListingCoordinates
    }

    getDefaultLogger().warn('Failed to load listing coordinates (fallback available)', response)
    return undefined
  } catch (error) {
    getDefaultLogger().warn('Failed to load listing coordinates', error)
    return undefined
  }
}
